# GraphQL fragment to delete a stage within the sales automation environment.

mutation StageDelete($stage: StageDeleteInputFieldInput!) {
    stageDelete(input: {stage: $stage}) {
        stage {
            id
        }
    }
}
